<template>
  <!--附件图片video预览显示-->
  <el-dialog :visible.sync="visibleShowEnclosure" width="70%" modal-append-to-body
             class="show-evidence__dailog enclosure-dialog"
             v-if="imgList.length>0" @close="closeView">
    <el-carousel height="500px" :autoplay="false" indicator-position="none"
                 :arrow="imgList.length>1?'always':'never'"
                 :initial-index="InitIndex"
                 v-if="isRefresh">
      <el-carousel-item v-for="(item, i) in imgList" :key="i" v-if="item.file" class="img-item"
                        :ref="'EnclosurePreview-' + i">
        <div>
          <h1 class="h-title">{{item.file.fileName}}</h1>
          <div class="box-wrap">
            <video v-if="isVideo(item)" controls="controls" height="100%">
              <source :src="showFile(item.file)" type="video/mp4">
              <source :src="showFile(item.file)" type="video/ogg">
              <source :src="showFile(item.file)" type="video/webm">
            </video>
            <img v-if="isImg(item)" :src="showFile(item.file)" :alt="item.file.fileName">
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </el-dialog>
</template>

<script>
  import {fileOperShow} from '../../assets/js/http-serve/http-methods';

  export default {
    name: "ViewFilesToImg",
    props: {
      visibleShow: {
        type: Boolean,
        default: false
      },
      imgList: {
        type: Array
      },
      isRefresh: {
        type: Boolean,
        default: true
      },
      enclosurePreviewNumItem: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    watch: {
      visibleShow(val) {
        this.InitIndex = this.getInitIndex();
        this.visibleShowEnclosure = val
      }
    },
    data() {
      return {
        InitIndex: this.getInitIndex(),
        visibleShowEnclosure: false,
      }
    },
    methods: {
      closeView() {
        this.$emit("setViewFilesToImgDialogData", {
          visibleShow: false,
          obj: {}
        });
      },
      showFile(json) {
        if (!json) return '';
        const v = fileOperShow(json);
        return v;
      },
      // 获取附件后缀
      getEnclosureSuffix(item) {
        if (item && item.file && item.file.fileName) {
          let arr = item.file.fileName.split('.')
          return arr[arr.length - 1]
        }
        return ''
      },
      // 附件是否是图片
      isImg(item) {
        let str = this.getEnclosureSuffix(item).toLocaleUpperCase()
        let arr = ['PNG', 'GIF', 'JPG', 'JPEG']
        if (arr.indexOf(str) > -1) {
          return true
        }
        return false
      },
      // 附件是否是视频
      isVideo(item) {
        let str = this.getEnclosureSuffix(item).toLocaleUpperCase()
        // let arr = ['MP4','RMVB','MKV','AVI']
        let arr = ['MP4', 'WEBM', 'OGG']
        // let arr = ['MP4']
        if (arr.indexOf(str) > -1) {
          return true
        }
        return false
      },
      // 获取附件弹窗预览时初始图片index
      getInitIndex() {
        // for (let i = 0; i < this.imgList.length; i++) {
        //   let item = this.imgList[i]
        //   if (item.attatchId && item.attatchId === this.enclosurePreviewNumItem.attatchId) {
        //     return i
        //   }else if(item.id && item.id === this.enclosurePreviewNumItem.id){
        //     return i
        //   } else {
        //     if (item.performanceId === this.enclosurePreviewNumItem.performanceId) {
        //       return i
        //     }
        //   }
        // }
        const index = this.imgList.findIndex((item, index) => {
          const keywords=Object.keys(this.enclosurePreviewNumItem),keys=['id','attatchId','performanceId'];
          const keyStr = keywords.filter(key => keys.includes(key))[0];
          console.log('keywords::::',keywords);
          console.log('keyStr::::',keyStr);
          console.log('item[keyStr]:::',item[keyStr]);
          console.log('this.enclosurePreviewNumItem[keyStr]:::',this.enclosurePreviewNumItem[keyStr]);
          
          if(item[keyStr] === this.enclosurePreviewNumItem[keyStr]){
            return index;
          }
          return 0;
        })
        return index>=0?index:0;
      },
    }
  }
</script>

<style lang="less" scoped>
  .enclosure-dialog {
    /deep/ .el-dialog__body {
      padding: 0;
    }

    /deep/ .el-dialog__headerbtn {
      z-index: 5;
    }

    .h-title {
      background: #ffffff;
      z-index: 2;
      line-height: initial;
      text-align: left;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      padding: 10px;
      width: 100%;
      /*position: absolute;*/
      /*top:0;*/
      /*left:0;*/
      /*right: 0;*/
      border-bottom: 1px solid #EEEEEE;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      box-sizing: border-box;
    }

    .box-wrap {
      height: 460px;
      line-height: 430px;
      padding: 15px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-height: 430px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/viewFiles/ViewFilesToImg.vue